import React from 'react';
import { createLazyPage } from '../createLazyPage';
import { AppRouteDefinition } from '../routeDefinition';
import { PermissionAddAccountingEntriesOutlet } from '../guards/PermissionOutlet';

const UserProfileManagementPage = createLazyPage(
  () =>
    import(
      '@app/modules/mje/pages/UserProfileManagement/UserProfileManagementPage'
    )
);

const ProfileManagementPage = createLazyPage(
  () => import('@app/modules/mje/pages/ProfileManagement/ProfileManagementPage')
);

const ApprovalLevelsPage = createLazyPage(
  () => import('@app/modules/mje/pages/ApprovalLevelsPage/ApprovalLevelsPage')
);

const MateraReintegrationPage = createLazyPage(
  () => import('@app/modules/mje/pages/Matera/MateraReintegrationPage')
);

const MateraReintegrationParametersPage = createLazyPage(
  () =>
    import('@app/modules/mje/pages/Matera/MateraReintegrationParametersPage')
);

const AccountingGuideListPage = createLazyPage(
  () =>
    import('@app/modules/mje/pages/AccountingGuideList/AccountingGuideListPage')
);

const ManualGuidePage = createLazyPage(
  () => import('@app/modules/mje/pages/ManualGuide/ManualGuide')
);

const AccountingGuideViewPage = createLazyPage(
  () =>
    import('@app/modules/mje/pages/AccountingGuideView/AccountingGuideViewPage')
);

const EditGuidePage = createLazyPage(
  () => import('@app/modules/mje/pages/ManualGuide/ManualGuide')
);

const GuideReportPage = createLazyPage(
  () => import('@app/modules/mje/pages/GuideReport/GuideReportPage')
);

const DelegationOfAuthorityPage = createLazyPage(
  () =>
    import(
      '@app/modules/mje/pages/DelegationOfAuthority/DelegationOfAuthorityPage'
    )
);

const AccountingSpreadsheetPage = createLazyPage(
  () =>
    import(
      '@app/modules/mje/pages/AccountingSpreadsheet/AccountingSpreadsheetPage'
    )
);

const FileProcessingPage = createLazyPage(
  () => import('@app/modules/mje/pages/FileProcessing/FileProcessingPage')
);

export const mjeMenuRoutes: AppRouteDefinition[] = [
  {
    key: 'mje-user-profile',
    path: 'mje/user-profile',
    element: <UserProfileManagementPage />,
  },
  {
    key: 'mje-cadastro-perfis',
    path: 'mje/cadastro-perfis',
    element: <ProfileManagementPage />,
  },
  {
    key: 'mje-approval-levels',
    path: 'contabilidade/alcada/alcadas',
    element: <ApprovalLevelsPage />,
  },
  {
    key: 'mje-matera-reintegracao-guias',
    path: 'mje/matera/reintegracao-guias',
    element: <MateraReintegrationPage />,
  },
  {
    key: 'mje-matera-reintegracao-parametros',
    path: 'mje/matera/reintegracao-parametros',
    element: <MateraReintegrationParametersPage />,
  },
  {
    key: 'mje-accounting-spreadsheet',
    path: 'contabilidade/planilhamento/parametrizacao',
    element: <AccountingSpreadsheetPage />,
  },
  {
    key: 'mje-file-processing',
    path: 'mje/processamento-arquivos',
    element: <FileProcessingPage />,
  },
];

export const mjeGuideFlowRoutes: AppRouteDefinition[] = [
  {
    key: 'mje-consulta-guias',
    path: 'mje/consulta-guias',
    element: <AccountingGuideListPage />,
  },
  {
    key: 'mje-nova-guia',
    path: 'mje/nova-guia',
    element: (
      <PermissionAddAccountingEntriesOutlet>
        <ManualGuidePage />
      </PermissionAddAccountingEntriesOutlet>
    ),
  },
  {
    key: 'mje-guia-view',
    path: 'mje/guia/:id',
    element: <AccountingGuideViewPage />,
  },
  {
    key: 'mje-guia-edit',
    path: 'mje/guia/:id/editar',
    element: <EditGuidePage />,
  },
  {
    key: 'mje-relatorio-guias',
    path: 'mje/relatorio-guias',
    element: <GuideReportPage />,
  },
  {
    key: 'mje-delegacao-autoridade',
    path: 'mje/delegacao-autoridade',
    element: <DelegationOfAuthorityPage />,
  },
];
